// extracted by mini-css-extract-plugin
module.exports = {"page":"Page-page-jTeFt","main":"Page-main-2lXDg"};